(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auto-metaobject-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('accordion-custom')) {
    class AccordionCustom extends HTMLElement {
      constructor() {
        super();
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.content = this.querySelector('.details-content');
      }
      connectedCallback() {
        if (this.details) {
          this.details.addEventListener('toggle', (e) => {
            // Optional: Add animation logic here if needed
          });
        }
      }
    }
    customElements.define('accordion-custom', AccordionCustom);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-announcements"] && !Shopify.designMode) return;
  try {
    

// ===== 关闭记忆（初始化）=====
const promoBar = document.getElementById('promo-bar');
promoBar.addEventListener('click',(e)=>{
 if (e.target.closest('.promo-code_1') || e.target.closest('.promo-close')) {
    return;
  }
  window.location.href="/pages/summer-sale-2026"
})
// const STORAGE_KEY = 'promo_bar_closed';

// if (localStorage.getItem(STORAGE_KEY)) {
//   promoBar.style.display = 'none';
// }

// ===== Copy Code =====
document.querySelectorAll('.promo-code_1').forEach(el => {
  el.addEventListener('click', function () {
    const code = this.dataset.code;

    navigator.clipboard.writeText(code);

    const copyText = this.querySelector('.copy-text');
    copyText.innerText = 'Copied!';

    setTimeout(() => {
      copyText.innerText = 'Copy';
    }, 2000);
  });
});

// ===== Countdown =====
document.querySelectorAll('.countdown').forEach(el => {
  const endTime = new Date(el.dataset.time).getTime();
  const display = el.querySelector('.time');

  function update() {
    const now = new Date().getTime();
    const diff = endTime - now;

    if (diff <= 0) {
      display.innerText = "Expired";
      return;
    }

    const d = Math.floor(diff / (1000*60*60*24));
    const h = Math.floor((diff / (1000*60*60)) % 24);
    const m = Math.floor((diff / (1000*60)) % 60);
    const s = Math.floor((diff / 1000) % 60);

    const pad = n => n.toString().padStart(2, '0');

    display.innerText = `${pad(d)}d : ${pad(h)}h : ${pad(m)}m : ${pad(s)}s`;
  }

  update();
  setInterval(update, 1000);
});

// ===== Close + 记忆 =====
// document.querySelector('.promo-close')?.addEventListener('click', function () {
//   promoBar.style.display = 'none';

//   // 保存关闭状态
//   //   localStorage.setItem(STORAGE_KEY, 'true');

// });

document.querySelector('.promo-close')?.addEventListener('click', function () {
  const promoBar = document.getElementById('promo-bar');

  // 隐藏 promo bar
  promoBar.style.display = 'none';

  // 给 header 添加类名
  const header = document.getElementById('header-component');
  if (header) {
    header.classList.add('header-active');
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-featured-product"] && !Shopify.designMode) return;
  try {
    


(function () {
  document.querySelectorAll('.featured_content_text').forEach(item => { 
      item.addEventListener('click', function (e) { 
          if (e.target.closest('a, button')) return; this.classList.toggle('active-btn'); 
      }); 
  });

  if (window.__VIDEO_BANNER_INIT__) return;
  window.__VIDEO_BANNER_INIT__ = true;

  const banners = document.querySelectorAll('.video-banner');
  if (!banners.length) return;

  let currentPlaying = null;

  // 获取当前设备视频
  function getActiveVideo(banner) {
    const pc = banner.querySelector('.video.pc');
    const mobile = banner.querySelector('.video.mobile');
    return window.matchMedia('(max-width: 1023px)').matches ? mobile : pc;
  }

  // 暂停所有
  function pauseAll() {
    banners.forEach(b => {
      const videos = b.querySelectorAll('video');
      videos.forEach(v => v.pause());
      b.classList.remove('playing');
    });
    currentPlaying = null;
  }

  // 播放指定 banner
  function playBanner(banner) {
    const video = getActiveVideo(banner);
    if (!video) return;

    if (currentPlaying && currentPlaying !== banner) {
      pauseAll();
    }

    video.muted = true; // 自动播放必须静音
    video.play().catch(() => {});

    banner.classList.add('playing');
    currentPlaying = banner;
  }

  // 初始化每个 banner
  function initBanner(banner) {
    if (banner.dataset.init) return;
    banner.dataset.init = "true";

    const btn = banner.querySelector('.play-btn');

    // 点击播放按钮
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();

        const video = getActiveVideo(banner);
        if (!video) return;

        if (!video.paused) {
          video.pause();
          banner.classList.remove('playing');
          currentPlaying = null;
        } else {
          playBanner(banner);
        }
      });
    }

    // 点击视频暂停
    banner.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', function () {
        video.pause();
        banner.classList.remove('playing');
        currentPlaying = null;
      });
    });
  }

  // 初始化全部
  banners.forEach(initBanner);

  // ===== 滚动自动播放（核心）=====
  const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {
      const banner = entry.target;

      if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
        // 进入视口 → 播放
        playBanner(banner);
      } else {
        // 离开视口 → 暂停
        const video = getActiveVideo(banner);
        if (video) {
          video.pause();
          banner.classList.remove('playing');
          if (currentPlaying === banner) {
            currentPlaying = null;
          }
        }
      }
    });

  }, {
    threshold: [0.6] // 60%可见才触发
  });

  banners.forEach(b => observer.observe(b));

  // Shopify 编辑器兼容
  document.addEventListener('shopify:section:load', function(e){
    e.target.querySelectorAll('.video-banner').forEach(initBanner);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["headspacex-detail-tabs"] && !Shopify.designMode) return;
  try {
    
  // Swiper web component handles initialization automatically

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-dual-banner"] && !Shopify.designMode) return;
  try {
    
(function () {

  if (window.__PROMO_PRO_INIT__) return;
  window.__PROMO_PRO_INIT__ = true;

  function initSection(section) {
    if (section.dataset.init) return;
    section.dataset.init = "true";

    const toast = section.querySelector('.toast');

    section.addEventListener('click', function(e){

      const btn = e.target.closest('.code-btn');
      if (!btn) return;

      const code = btn.dataset.code;

      navigator.clipboard.writeText(code);

      /* toast */
      if (toast) {
        toast.classList.add('show');
        setTimeout(()=> toast.classList.remove('show'), 1500);
      }

      const original = btn.innerText;
      btn.innerText = "Copied!";
      btn.disabled = true;

      setTimeout(()=>{
        btn.innerText = original;
        btn.disabled = false;
      },1500);

      // window.location.href = `/discount/${code}?redirect=/cart`;

    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll('.promo-pro').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', function(){
    initAll();
  });

  document.addEventListener('shopify:section:load', function(e){
    initAll(e.target);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renpho-comparison-table"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('renpho-comparison-table')) {
    class RenphoComparisonTable extends HTMLElement {
      #controller = new AbortController();
      #mediaQuery = window.matchMedia('(min-width: 990px)');

      connectedCallback() {
        const { signal } = this.#controller;
        this.addEventListener('renpho:change-product', this.#handleProductChange.bind(this), { signal });
        this.#updateHiddenClasses();
        this.#mediaQuery.addEventListener('change', this.#updateHiddenClasses.bind(this), { signal });
        window.addEventListener('resize', this.#updateHiddenClasses.bind(this), { signal });
      }

      disconnectedCallback() {
        this.#controller.abort();
      }

      #handleProductChange(event) {
        const { selectedProductId, currentProductId, currentColumnIndex } = event.detail;
        this.#swapColumns(selectedProductId, currentProductId, currentColumnIndex);
      }

      #isMobile() {
        return !this.#mediaQuery.matches;
      }

      #updateHiddenClasses() {
        const isMobile = this.#isMobile();
        const hiddenClass = 'renpho-comparison__item--hidden';

        const items = Array.from(this.querySelectorAll('.renpho-comparison__item'));
        const cells = Array.from(
          this.querySelectorAll('.renpho-comparison__table-cell, .renpho-comparison__table-group-icon-cell')
        );

        items.forEach((item) => {
          const htmlItem = /** @type {HTMLElement} */ (item);
          const order = this.#getOrderValue(htmlItem, parseInt(htmlItem.dataset.columnIndex || '0', 10));
          
          if (isMobile) {
            if (order !== 0 && order !== 1) {
              htmlItem.classList.add(hiddenClass);
            } else {
              htmlItem.classList.remove(hiddenClass);
            }
          } else {
            if (order >= 3) {
              htmlItem.classList.add(hiddenClass);
            } else {
              htmlItem.classList.remove(hiddenClass);
            }
          }
        });

        cells.forEach((cell) => {
          const htmlCell = /** @type {HTMLElement} */ (cell);
          const columnIndex = parseInt(htmlCell.dataset.columnIndex || '0', 10);
          const order = this.#getOrderValue(htmlCell, columnIndex);
          
          if (isMobile) {
            if (order !== 0 && order !== 1) {
              htmlCell.classList.add(hiddenClass);
            } else {
              htmlCell.classList.remove(hiddenClass);
            }
          } else {
            if (order >= 3) {
              htmlCell.classList.add(hiddenClass);
            } else {
              htmlCell.classList.remove(hiddenClass);
            }
          }
        });
      }

      #findProductColumn(productId) {
        const table = this.querySelector('.renpho-comparison__table');
        if (!table) return null;

        const cell = table.querySelector(`[data-product-id="${productId}"]`);
        if (!cell) return null;

        const htmlCell = /** @type {HTMLElement} */ (cell);
        return parseInt(htmlCell.dataset.columnIndex || '0', 10);
      }

      #getOrderValue(element, columnIndex) {
        const inlineOrder = element.style.order;
        if (inlineOrder) {
          return parseInt(inlineOrder, 10);
        }
        const computedOrder = getComputedStyle(element).order;
        if (computedOrder && computedOrder !== 'auto' && computedOrder !== '0') {
          return parseInt(computedOrder, 10);
        }
        return columnIndex;
      }

      #swapColumns(selectedProductId, currentProductId, currentColumnIndex) {
        const table = this.querySelector('.renpho-comparison__table');
        if (!table) return;

        const selectedColumnIndex = this.#findProductColumn(selectedProductId);
        if (selectedColumnIndex === null || selectedColumnIndex === currentColumnIndex) {
          return;
        }

        const rows = Array.from(
          table.querySelectorAll('.renpho-comparison__table-row, .renpho-comparison__table-group-icon-row')
        );

        let currentOrder = currentColumnIndex;
        let selectedOrder = selectedColumnIndex;

        if (rows.length > 0 && rows[0]) {
          const firstRowCells = Array.from(rows[0].querySelectorAll('[data-column-index]'));
          const currentCell = firstRowCells.find(
            (cell) => parseInt(/** @type {HTMLElement} */ (cell).dataset.columnIndex || '0', 10) === currentColumnIndex
          );
          const selectedCell = firstRowCells.find(
            (cell) => parseInt(/** @type {HTMLElement} */ (cell).dataset.columnIndex || '0', 10) === selectedColumnIndex
          );

          if (currentCell) {
            currentOrder = this.#getOrderValue(/** @type {HTMLElement} */ (currentCell), currentColumnIndex);
          }
          if (selectedCell) {
            selectedOrder = this.#getOrderValue(/** @type {HTMLElement} */ (selectedCell), selectedColumnIndex);
          }
        }

        rows.forEach((row) => {
          const cells = Array.from(row.querySelectorAll('[data-column-index]'));
          cells.forEach((cell) => {
            const htmlCell = /** @type {HTMLElement} */ (cell);
            const columnIndex = parseInt(htmlCell.dataset.columnIndex || '0', 10);
            if (columnIndex === currentColumnIndex) {
              htmlCell.style.order = selectedOrder.toString();
            } else if (columnIndex === selectedColumnIndex) {
              htmlCell.style.order = currentOrder.toString();
            }
          });
        });

        const gridItems = Array.from(this.querySelectorAll('.renpho-comparison__item'));
        gridItems.forEach((item) => {
          const htmlItem = /** @type {HTMLElement} */ (item);
          const columnIndex = parseInt(htmlItem.dataset.columnIndex || '0', 10);
          if (columnIndex === currentColumnIndex) {
            htmlItem.style.order = selectedOrder.toString();
          } else if (columnIndex === selectedColumnIndex) {
            htmlItem.style.order = currentOrder.toString();
          }
        });

        this.#updateHiddenClasses();
      }
    }
    customElements.define('renpho-comparison-table', RenphoComparisonTable);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-featured-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sb-featured-collections')) {
    class SbFeaturedCollections extends HTMLElement {
      constructor() {
        super();
        this.modalContainer = null;
        this.observer = null;
        this.clonedCard = null;
        this.toggleButtonHandlers = [];
        this.originalCard = null;
        this.handleEscapeKey = null;
        this.handleBackdropClick = null;
      }

      connectedCallback() {
        try {
          this.modalContainer = this.querySelector('.sb-featured-collections__modal');
          this.observeModals();
        } catch (error) {
          console.error('[SbFeaturedCollections] Initialization error:', error);
        }
      }

      observeModals() {
        // Find all collection modal elements
        const collectionModals = this.querySelectorAll('._sb-featured-collection__modal');

        if (collectionModals.length === 0) return;

        // Create a MutationObserver to watch for class changes
        this.observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const target = mutation.target;

              // Check if the modal gained the 'active' class
              if (target.classList.contains('active') && target.classList.contains('_sb-featured-collection__modal')) {
                const card = target.closest('._sb-featured-collection__card');
                if (card) {
                  this.handleModalActivation(card);
                }
              }
            }
          });
        });

        // Observe each modal for class changes
        collectionModals.forEach((modal) => {
          this.observer.observe(modal, {
            attributes: true,
            attributeFilter: ['class'],
          });
        });
      }

      handleModalActivation(card) {
        // Only activate full-screen modal on mobile and tablet (below 1024px)
        if (window.innerWidth >= 767) {
          return;
        }

        // Close any existing full-screen modal first
        this.closeFullScreenModal();

        // Store reference to the original card for later
        this.originalCard = card;

        // Clone the entire card
        this.clonedCard = card.cloneNode(true);

        // Insert cloned card into modal container first
        this.modalContainer.appendChild(this.clonedCard);

        // Find ALL toggle buttons in the cloned card (there are multiple)
        const toggleButtons = this.clonedCard.querySelectorAll('._sb-featured-collection__modal-toggle');

        // Add click handlers to all toggle buttons with capture phase to intercept before other listeners
        this.toggleButtonHandlers = [];
        toggleButtons.forEach((button) => {
          const handler = (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            this.closeModalAndOriginal();
          };
          // Use capture phase (true) to intercept the event before the sb-featured-collection's listener
          button.addEventListener('click', handler, true);
          this.toggleButtonHandlers.push({ button, handler });
        });

        // Activate the full-screen modal
        this.modalContainer.classList.add('sb-featured-collections__modal--active');

        // Add escape key listener
        this.handleEscapeKey = (e) => {
          if (e.key === 'Escape') {
            this.closeModalAndOriginal();
          }
        };
        document.addEventListener('keydown', this.handleEscapeKey);

        // Add backdrop click listener
        this.handleBackdropClick = (e) => {
          // Only close if clicking directly on the modal container (backdrop), not its children
          if (e.target === this.modalContainer) {
            this.closeModalAndOriginal();
          }
        };
        this.modalContainer.addEventListener('click', this.handleBackdropClick);
      }

      closeModalAndOriginal() {
        // Remove active class from original modal
        if (this.originalCard) {
          const originalModal = this.originalCard.querySelector('._sb-featured-collection__modal');
          if (originalModal) {
            originalModal.classList.remove('active');
          }
        }

        // Close the full-screen modal
        this.closeFullScreenModal();
      }

      closeFullScreenModal() {
        // Remove toggle button event listeners
        if (this.toggleButtonHandlers.length > 0) {
          this.toggleButtonHandlers.forEach(({ button, handler }) => {
            button.removeEventListener('click', handler, true);
          });
          this.toggleButtonHandlers = [];
        }

        // Remove cloned content
        if (this.clonedCard) {
          this.clonedCard.remove();
          this.clonedCard = null;
        }

        // Clear original card reference
        this.originalCard = null;

        // Remove escape key listener
        if (this.handleEscapeKey) {
          document.removeEventListener('keydown', this.handleEscapeKey);
          this.handleEscapeKey = null;
        }

        // Remove backdrop click listener
        if (this.handleBackdropClick && this.modalContainer) {
          this.modalContainer.removeEventListener('click', this.handleBackdropClick);
          this.handleBackdropClick = null;
        }

        // Deactivate the full-screen modal
        if (this.modalContainer) {
          this.modalContainer.classList.remove('sb-featured-collections__modal--active');
        }
      }

      disconnectedCallback() {
        // Clean up observer
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }

        // Clean up any remaining cloned content
        this.closeFullScreenModal();
      }
    }

    customElements.define('sb-featured-collections', SbFeaturedCollections);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-recommended"] && !Shopify.designMode) return;
  try {
    
  class SbRecommended extends HTMLElement {
    /**
     * The observer for the product recommendations
     * @type {IntersectionObserver}
     */
    #intersectionObserver = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0]?.isIntersecting) return;

        observer.disconnect();
        this.#loadRecommendations();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );

    /**
     * Observing changes to the elements attributes
     * @type {MutationObserver}
     */
    #mutationObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        // Only attribute changes are interesting
        if (mutation.target !== this || mutation.type !== 'attributes') continue;

        // Ignore when the data-recommendations-performed attribute has been set to 'true'
        if (
          mutation.attributeName === 'data-recommendations-performed' &&
          this.dataset.recommendationsPerformed === 'true'
        )
          continue;

        // All other attribute changes trigger a reload
        this.#loadRecommendations();
        break;
      }
    });

    /**
     * The cached recommendations
     * @type {Record<string, string>}
     */
    #cachedRecommendations = {};

    /**
     * An abort controller for the active fetch (if there is one)
     * @type {AbortController | null}
     */
    #activeFetch = null;

    connectedCallback() {
      this.#intersectionObserver.observe(this);
      this.#mutationObserver.observe(this, { attributes: true });
    }

    disconnectedCallback() {
      this.#intersectionObserver.disconnect();
      this.#mutationObserver.disconnect();
      this.#activeFetch?.abort();
    }

    /**
     * Load the product recommendations
     */
    #loadRecommendations() {
      const { productId, recommendationsPerformed, sectionId, intent } = this.dataset;
      const id = this.id;

      if (!productId || !id) {
        throw new Error('Product ID and an ID attribute are required');
      }

      // If the recommendations have already been loaded, accounts for the case where the Theme Editor
      // is loaded the section from the editor's visual preview context.
      if (recommendationsPerformed === 'true') {
        return;
      }

      this.#fetchCachedRecommendations(productId, sectionId, intent)
        .then((result) => {
          if (!result.success) {
            // The Theme Editor will place a section element element in the DOM whose section_id is not available
            // to the Section Renderer API. In this case, we can safely ignore the error.
            if (!Shopify.designMode) {
              this.#handleError(new Error(`Server returned ${result.status}`));
            }
            return;
          }

          const html = document.createElement('div');
          html.innerHTML = result.data || '';
          const recommendations = html.querySelector(`sb-recommended[id="${id}"]`);

          if (recommendations?.innerHTML && recommendations.innerHTML.trim().length) {
            this.dataset.recommendationsPerformed = 'true';
            this.innerHTML = recommendations.innerHTML;
            // Notify any swiper-slider instances inserted by recommendations to reinitialize
            // We defer to the next animation frame to ensure custom elements are upgraded and connected
            this.#requestSwiperReinitialize().catch(err => {
              console.error('[SbRecommended] Promise rejection from requestSwiperReinitialize:', err);
            });
          } else {
            this.#handleError(new Error('No recommendations available'));
          }
        })
        .catch((e) => {
          this.#handleError(e);
        });
    }

    /**
     * Fetches the recommendations and caches the result for future use
     * @param {string} productId
     * @param {string | undefined} sectionId
     * @param {string | undefined} intent
     * @returns {Promise<{ success: true, data: string } | { success: false, status: number }>}
     */
    async #fetchCachedRecommendations(productId, sectionId, intent) {
      const url = `${this.dataset.url}&product_id=${productId}&section_id=${sectionId}&intent=${intent}`;

      const cachedResponse = this.#cachedRecommendations[url];
      if (cachedResponse) {
        return { success: true, data: cachedResponse };
      }

      this.#activeFetch?.abort();
      this.#activeFetch = new AbortController();

      try {
        const response = await fetch(url, { signal: this.#activeFetch.signal });
        if (!response.ok) {
          return { success: false, status: response.status };
        }

        const text = await response.text();
        this.#cachedRecommendations[url] = text;
        return { success: true, data: text };
      } finally {
        this.#activeFetch = null;
      }
    }

    /**
     * Handle errors in a consistent way
     * @param {Error} error
     */
    #handleError(error) {
      console.error('Product recommendations error:', error);
      this.classList.add('hidden');
      this.dataset.error = 'Error loading product recommendations';
    }

    /**
     * Ensures the Swiper library is loaded before attempting to reinitialize sliders.
     * The main swiper-slider.js script only loads if swiper elements exist at DOMContentLoaded,
     * so we need to manually trigger loading when recommendations inject sliders dynamically.
     */
    async #ensureSwiperLoaded() {
      // Check if Swiper script is already loaded
      if (customElements.get('swiper-slider')) {
        return;
      }
      
      // Find the Swiper script URL from the page
      const swiperScriptURL = document.querySelector('[data-swiper-script]')?.dataset.swiperScript;
      if (!swiperScriptURL) {
        throw new Error('Swiper script URL not found');
      }

      // Load the Swiper library script if not already loaded
      if (!window.Swiper) {
        await new Promise((resolve, reject) => {
          const swiperScript = document.createElement('script');
          swiperScript.src = swiperScriptURL;
          swiperScript.async = true;
          swiperScript.onload = resolve;
          swiperScript.onerror = reject;
          document.head.appendChild(swiperScript);
        });
      }

      // Trigger custom element declaration
      if (typeof declareSwiperCustomElement === 'function') {
        declareSwiperCustomElement();
      } else {
        throw new Error('declareSwiperCustomElement function not found');
      }

      // Wait for custom element to be defined
      await customElements.whenDefined('swiper-slider');
    }

    /**
     * Dispatches a custom event to any descendant swiper-slider components so they
     * can reinitialize sizing once recommendations markup has been injected.
     * Waits for custom element definition and upgrade before dispatching.
     */
    async #requestSwiperReinitialize() {
      try {
        
        // Ensure Swiper is loaded and custom element is defined
        await this.#ensureSwiperLoaded();
        
        // Ensure connectedCallback has completed
        await new Promise(resolve => requestAnimationFrame(resolve));
        
        const swipers = this.querySelectorAll('swiper-slider');
        
        swipers.forEach((el) => {
          try {
            el.dispatchEvent(new CustomEvent('reinitialize-swiper', { bubbles: false }));
          } catch (err) {
            console.warn('[SbRecommended] Failed to dispatch reinitialize-swiper', err);
          }
        });
      } catch (err) {
        console.error('[SbRecommended] Error in requestSwiperReinitialize:', err);
      }
    }
  }

  if (!customElements.get('sb-recommended')) {
    customElements.define('sb-recommended', SbRecommended);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-collection-tabs-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (customElements.get('td-product-collection-tabs')) {
      return;
    }

    class TdProductCollectionTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = this.querySelectorAll('.td-product-collection-tabs__tab');
        this.panels = this.querySelectorAll('.td-product-collection-tabs__panel');
        this.shopAllLink = this.querySelector('[data-shop-all-link] a');
        this.mobileShopAllLink = this.querySelector('[data-mobile-shop-all-link] a');
        this.shopAllLabel = this.getAttribute('data-shop-all-label') || 'Shop all';
      }

      connectedCallback() {
        this.setupEventListeners();
        this.updateShopAllLink();
        this.updateTitle();
      }

      setupEventListeners() {
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            this.switchTab(tab.dataset.tab);
          });
        });
      }

      switchTab(tabId) {
        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.tab === tabId;
          tab.classList.toggle('active', isActive);
          tab.setAttribute('aria-selected', isActive);
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.panel === tabId;
          panel.classList.toggle('active', isActive);
        });

        this.updateShopAllLink();
        this.updateTitle();
      }

      updateTitle() {
        const titleElement = this.querySelector('.td-product-collection-tabs__title.td-product-collection-tabs__title--dynamic');
        const activePanel = this.querySelector('.td-product-collection-tabs__panel.active');

        if (titleElement && activePanel && activePanel.dataset.collectionTitle) {
          titleElement.textContent = activePanel.dataset.collectionTitle;
        }
      }

      updateShopAllLink() {
        const activePanel = this.querySelector('.td-product-collection-tabs__panel.active');

        if (!activePanel || !activePanel.dataset.collectionHandle || !activePanel.dataset.collectionTitle) {
          return;
        }

        const shopAllText = `${this.shopAllLabel} ${activePanel.dataset.collectionTitle.toLowerCase()}`;
        const shopAllUrl = `/collections/${activePanel.dataset.collectionHandle}`;

        if (this.shopAllLink) {
          this.shopAllLink.textContent = shopAllText;
          this.shopAllLink.href = shopAllUrl;
        }

        if (this.mobileShopAllLink) {
          this.mobileShopAllLink.textContent = shopAllText;
          this.mobileShopAllLink.href = shopAllUrl;
        }
      }
    }

    customElements.define('td-product-collection-tabs', TdProductCollectionTabs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    class CollectionTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = this.querySelectorAll('.collection-tabs__tab');
        this.panels = this.querySelectorAll('.collection-tabs__panel');
        this.shopAllLink = this.querySelector('[data-shop-all-link] a');
        this.mobileShopAllLink = this.querySelector('[data-mobile-shop-all-link] a');
        this.shopAllLabel = this.getAttribute('data-shop-all-label') || 'Shop all';
      }

      connectedCallback() {
        this.setupEventListeners();
        this.updateShopAllLink();
        this.updateTitle();
      }

      setupEventListeners() {
        this.tabs.forEach(tab => {
          tab.addEventListener('click', () => {
            this.switchTab(tab.dataset.tab);
          });
        });
      }

      switchTab(tabId) {
        this.tabs.forEach(tab => {
          const isActive = tab.dataset.tab === tabId;
          tab.classList.toggle('active', isActive);
          tab.setAttribute('aria-selected', isActive);
        });

        this.panels.forEach(panel => {
          const isActive = panel.dataset.panel === tabId;
          panel.classList.toggle('active', isActive);
        });

        this.updateShopAllLink();
        this.updateTitle();
      }

      updateTitle() {
        const titleElement = this.querySelector('.collection-tabs__title.collection-tabs__title--dynamic');
        const activePanel = this.querySelector('.collection-tabs__panel.active');
        if (titleElement && activePanel) {
          titleElement.textContent = activePanel.dataset.collectionTitle;
        }
      }

      updateShopAllLink() {
        const activePanel = this.querySelector('.collection-tabs__panel.active');
        if (activePanel && this.shopAllLink && this.mobileShopAllLink) {
          const collectionHandle = activePanel.dataset.collectionHandle;
          const collectionTitle = activePanel.dataset.collectionTitle;
          const shopAllText = `${this.shopAllLabel} ${collectionTitle.toLowerCase()}`;
          const shopAllUrl = `/collections/${collectionHandle}`;

          this.shopAllLink.textContent = shopAllText;
          this.shopAllLink.href = shopAllUrl;
          this.mobileShopAllLink.textContent = shopAllText;
          this.mobileShopAllLink.href = shopAllUrl;
        }
      }
    }

    customElements.define('collection-tabs', CollectionTabs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get("sb-marquee")) {
    class TDMarquee extends HTMLElement {
      constructor() {
        super();

        // The number 10 is arbitrary
        // This component can stutter during the animation reset
        // A large size reduces stutters and delays the first until a low importance time
        this.SIZE_MULTIPLIER = 10;

        this.trackCount = 1;
        this.trackWidth = 0;
        /** @type {HTMLDivElement | null} */
        this.TRACK = null;
        this._handleResize = null;

        // Drag/swipe state
        this._isDragging = false;
        this._startX = 0;
        this._startY = 0;
        this._currentTranslateX = 0;
        this._dragDelta = 0;
        this._dragController = null;
      }

      connectedCallback() {
        // Get settings from data attributes
        this.enableSwipe = this.dataset.enableSwipe === 'true';

        this._handleResize =
          this._handleResize || this.debounce(this.handleResize.bind(this), 100);

        window.addEventListener("resize", this._handleResize);

        // Add drag/swipe listener if enabled
        if (this.enableSwipe) {
          this._handlePointerDown = this._handlePointerDown || this.handlePointerDown.bind(this);
          this.addEventListener("pointerdown", this._handlePointerDown);
        }

        window.requestAnimationFrame(() => {
          this.duplicateTrackIfNeeded();
        });
      }

      disconnectedCallback() {
        // Remove resize listener
        if (this._handleResize) {
          window.removeEventListener("resize", this._handleResize);
        }
        
        // Remove pointer listener
        if (this._handlePointerDown) {
          this.removeEventListener("pointerdown", this._handlePointerDown);
        }
        
        // Abort any active drag operation and clean up document listeners
        if (this._dragController) {
          this._dragController.abort();
          this._dragController = null;
        }
        
        // Reset drag state
        if (this._isDragging) {
          this._isDragging = false;
          this.classList.remove('is-dragging');
        }
      }

      updateTrackMetrics() {
        /** @type {NodeListOf<HTMLDivElement>} */
        const trackElements = this.querySelectorAll(".sb-track");

        this.trackCount = trackElements.length || 1;
        this.TRACK = trackElements[0] || null;
        this.trackWidth = 0;

        if (this.TRACK) {
          const singleTrackWidth = this.TRACK.offsetWidth;

          if (singleTrackWidth > 0) {
            this.trackWidth = singleTrackWidth * this.trackCount;
          }
        }
      }

      duplicateTrackIfNeeded() {
        this.updateTrackMetrics();

        if (!this.TRACK || this.trackWidth === 0) {
          return;
        }

        const originalTrackWidth = this.TRACK.offsetWidth;

        if (!originalTrackWidth) {
          return;
        }

        while (this.trackWidth < window.innerWidth * this.SIZE_MULTIPLIER) {
          const newTrack = /** @type {HTMLDivElement} */ (
            this.TRACK.cloneNode(true)
          );

          newTrack.setAttribute("aria-hidden", "true");

          const parentNode = this.TRACK.parentNode;

          if (!parentNode) {
            break;
          }

          parentNode.appendChild(newTrack);

          this.trackWidth += originalTrackWidth;
          this.trackCount += 1;
        }

        this.style.setProperty("--track-count", String(this.trackCount));
      }

      handleResize() {
        if (window.innerWidth < 767) {
          return;
        }

        this.duplicateTrackIfNeeded();
      }

      /**
       * Gets the current translateX value from the computed transform matrix
       * @param {HTMLElement} element - The element to get transform from
       * @returns {number} The current translateX value in pixels
       */
      getTranslateX(element) {
        const style = window.getComputedStyle(element);
        const transform = style.transform;

        if (!transform || transform === 'none') {
          return 0;
        }

        // Parse the matrix transform value
        // matrix(a, b, c, d, tx, ty) - tx is the translateX value
        const matrix = transform.match(/matrix.*\((.+)\)/);
        if (matrix && matrix[1]) {
          const values = matrix[1].split(', ');
          return parseFloat(values[4]) || 0;
        }

        return 0;
      }

      /**
       * Handles the pointerdown event to start dragging
       * @param {PointerEvent} event - The pointerdown event
       */
      handlePointerDown(event) {
        // Only handle primary pointer (left mouse button or first touch)
        if (event.button !== 0) return;
        
        // Don't start drag if already dragging
        if (this._isDragging) return;

        const tracks = this.querySelectorAll('.sb-track--marquee');
        if (!tracks.length) return;

        // Prevent default to stop native image drag behavior
        event.preventDefault();

        // Store the starting position
        this._startX = event.clientX;
        this._startY = event.clientY;
        
        // Get the current translateX from the first track (they all animate together)
        const firstTrack = /** @type {HTMLElement} */ (tracks[0]);
        this._currentTranslateX = this.getTranslateX(firstTrack);
        this._dragDelta = 0;

        // Set up event listeners for drag tracking
        this._dragController = new AbortController();
        const { signal } = this._dragController;

        /**
         * Handles the pointermove event during drag
         * @param {PointerEvent} moveEvent - The pointermove event
         */
        const onPointerMove = (moveEvent) => {
          const deltaX = moveEvent.clientX - this._startX;
          const deltaY = moveEvent.clientY - this._startY;
          
          // Only start dragging after a small threshold to differentiate from clicks
          // and only if horizontal movement is greater than vertical (to allow page scroll)
          if (!this._isDragging && Math.abs(deltaX) > 5) {
            // If user is swiping more vertically than horizontally, let the page scroll
            if (Math.abs(deltaY) > Math.abs(deltaX)) {
              this._dragController?.abort();
              return;
            }
            
            this._isDragging = true;
            this.classList.add('is-dragging');
            try {
              this.setPointerCapture(moveEvent.pointerId);
            } catch {
              // Pointer capture may fail if pointer was released
            }
          }

          if (this._isDragging) {
            // Prevent page scroll while dragging horizontally
            moveEvent.preventDefault();
            
            this._dragDelta = deltaX;
            
            // Apply the transform to all tracks
            const newTranslateX = this._currentTranslateX + deltaX;
            tracks.forEach((track) => {
              /** @type {HTMLElement} */ (track).style.transform = `translateX(${newTranslateX}px)`;
            });
          }
        };

        /**
         * Handles the pointerup event to end dragging
         * @param {PointerEvent} upEvent - The pointerup event
         */
        const onPointerUp = (upEvent) => {
          this._dragController?.abort();
          
          if (!this._isDragging) return;

          try {
            if (this.hasPointerCapture(upEvent.pointerId)) {
              this.releasePointerCapture(upEvent.pointerId);
            }
          } catch {
            // Pointer capture may not exist or was already released
          }
          this._isDragging = false;
          this.classList.remove('is-dragging');

          // Calculate the new position and resume animation
          this.resumeAnimationFromPosition(tracks);
        };

        document.addEventListener('pointermove', onPointerMove, { signal });
        document.addEventListener('pointerup', onPointerUp, { signal });
        document.addEventListener('pointercancel', onPointerUp, { signal });
      }

      /**
       * Resumes the animation from the current drag position
       * @param {NodeListOf<Element>} tracks - The track elements
       */
      resumeAnimationFromPosition(tracks) {
        if (!tracks.length || !this.TRACK) return;

        const singleTrackWidth = this.TRACK.offsetWidth;
        
        if (!singleTrackWidth) return;

        // Get the final translateX position after drag
        const finalTranslateX = this._currentTranslateX + this._dragDelta;
        
        // Calculate the iteration count (matches CSS --iteration-reduction: 2)
        const iterationCount = Math.max(1, this.trackCount - 2);
        const totalAnimationDistance = singleTrackWidth * iterationCount;
        
        // The animation moves from translateX(0) to translateX(-totalAnimationDistance)
        // Wrap the position to be within the animation cycle [-totalAnimationDistance, 0]
        let wrappedPosition = finalTranslateX % totalAnimationDistance;
        
        // If position is positive (user dragged right past start), wrap to negative
        if (wrappedPosition > 0) {
          wrappedPosition = wrappedPosition - totalAnimationDistance;
        }
        
        // Calculate animation progress (0 to 1)
        // At position 0, progress = 0; at position -totalAnimationDistance, progress = 1
        const animationProgress = Math.abs(wrappedPosition) / totalAnimationDistance;
        
        // Get the base speed from CSS variable (default 30s per iteration)
        const computedStyle = window.getComputedStyle(this);
        const marqueeSpeedStr = computedStyle.getPropertyValue('--marquee-speed').trim();
        const marqueeSpeed = parseFloat(marqueeSpeedStr) || 30;
        
        // Total animation duration = speed * iterationCount
        const totalDuration = marqueeSpeed * iterationCount;
        
        // Calculate the negative delay to start from the current position
        const delay = -(animationProgress * totalDuration);

        // Remove inline transforms and apply animation delay to restart from position
        tracks.forEach((track) => {
          const trackEl = /** @type {HTMLElement} */ (track);
          trackEl.style.transform = '';
          trackEl.style.animationDelay = `${delay}s`;
        });
      }

      /**
       * @param {(this: any, ...args: any[]) => void} func
       * @param {number} delay
       * @returns {(this: any, ...args: any[]) => void}
       */
      debounce(func, delay) {
        /** @type {number | undefined} */
        let timeoutId;

        return function debounced(...args) {
          const context = this;

          clearTimeout(timeoutId);

          timeoutId = setTimeout(() => {
            func.apply(context, args);
          }, delay);
        };
      }
    }

    customElements.define("sb-marquee", TDMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-product-specs"] && !Shopify.designMode) return;
  try {
    
class ProductTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll(".td-product-specs__tabs li"));
    this.panels = Array.from(this.querySelectorAll(".td-product-specs__tab-panel"));

    if (this.tabs.length === 0) return;

    this.syncTabPanelIds();

    this.tabs.forEach((tab, index) => {
      tab.addEventListener("click", (e) => this.onTabClick(e));
      tab.addEventListener("keydown", (e) => this.onKeyDown(e, index));
    });

    this.setActiveTab(this.tabs[0]);
  }

  syncTabPanelIds() {
    this.tabs.forEach((tab, i) => {
      tab.id = `tab-${i}`;
      tab.setAttribute("role", "tab");
      tab.setAttribute("aria-controls", `panel-${i}`);
      tab.dataset.tab = i;
    });

    this.panels.forEach((panel, i) => {
      panel.id = `panel-${i}`;
      panel.setAttribute("role", "tabpanel");
      panel.classList.remove("td-product-specs__tab-panel--active");

      const tab = this.tabs[i];
      if (tab) {
        panel.setAttribute("aria-labelledby", tab.id);
      }
    });
  }

  onTabClick(e) {
    const clicked = e.currentTarget || e.target;
    this.setActiveTab(clicked);
  }

  onKeyDown(e, index) {
    const key = e.key;
    const ctrl = e.ctrlKey || e.metaKey;

    switch (key) {
      case "ArrowRight":
        e.preventDefault();
        this.focusTab((index + 1) % this.tabs.length);
        break;
      case "ArrowLeft":
        e.preventDefault();
        this.focusTab((index - 1 + this.tabs.length) % this.tabs.length);
        break;
      case "Home":
        e.preventDefault();
        this.focusTab(0);
        break;
      case "End":
        e.preventDefault();
        this.focusTab(this.tabs.length - 1);
        break;
      case "Enter":
      case " ":
      case "Spacebar":
        e.preventDefault();
        this.setActiveTab(this.tabs[index]);
        break;
      default:
        break;
    }
  }

  focusTab(index) {
    const tab = this.tabs[index];
    if (!tab) return;
    this.tabs.forEach(t => t.setAttribute("tabindex", "-1"));
    tab.setAttribute("tabindex", "0");
    tab.focus();
  }

  setActiveTab(selectedTab) {
    if (!selectedTab) return;
    const selectedIndex = Number(selectedTab.dataset.tab);

    this.tabs.forEach((tab, i) => {
      const isSelected = tab === selectedTab;
      tab.classList.toggle("active", isSelected);
      tab.setAttribute("aria-selected", isSelected ? "true" : "false");
      tab.setAttribute("tabindex", isSelected ? "0" : "-1");
    });

    this.panels.forEach((panel, i) => {
      const show = i === selectedIndex;
      panel.classList.toggle("td-product-specs__tab-panel--hidden", !show);
      panel.setAttribute("aria-hidden", show ? "false" : "true");
      panel.setAttribute("tabindex", show ? "0" : "-1");
    });
  }
}

if (!customElements.get("product-tabs")) {
  customElements.define("product-tabs", ProductTabs);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-products-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-products-comparison')) {
    /**
     * Comparison section component that handles column swapping.
     * Listens for product change events and updates the table accordingly.
     *
     * @extends {HTMLElement}
     */
    class TdProductsComparison extends HTMLElement {
      #controller = new AbortController();
      #mediaQuery = window.matchMedia('(min-width: 990px)');

      connectedCallback() {
        const { signal } = this.#controller;

        this.addEventListener('td:change-product', this.#handleProductChange.bind(this), { signal });
        
        // Update hidden classes on initial load
        this.#updateHiddenClasses();
        
        // Listen for resize events to update hidden classes
        this.#mediaQuery.addEventListener('change', this.#updateHiddenClasses.bind(this), { signal });
        window.addEventListener('resize', this.#updateHiddenClasses.bind(this), { signal });
      }

      disconnectedCallback() {
        this.#controller.abort();
      }

      /**
       * Handles the product change event and swaps columns.
       * @param {CustomEvent} event - The td:change-product event.
       */
      #handleProductChange(event) {
        const { selectedProductId, currentProductId, currentColumnIndex } = event.detail;
        this.#swapColumns(selectedProductId, currentProductId, currentColumnIndex);
      }

      /**
       * Checks if the current viewport is mobile (less than 990px).
       * @returns {boolean} True if mobile, false if desktop.
       */
      #isMobile() {
        return !this.#mediaQuery.matches;
      }

      /**
       * Updates hidden classes based on order values and screen size.
       * Mobile: order 0 and 1 visible, order 2+ hidden
       * Desktop: order 0, 1, and 2 visible, order 3+ hidden
       */
      #updateHiddenClasses() {
        const isMobile = this.#isMobile();
        const hiddenClass = 'td-products-comparison__item--hidden';

        // Get all items and cells with order values
        const items = Array.from(this.querySelectorAll('.td-products-comparison__item'));
        const cells = Array.from(
          this.querySelectorAll('.td-products-comparison__table-cell, .td-products-comparison__table-group-icon-cell')
        );

        // Update items
        items.forEach((item) => {
          const htmlItem = /** @type {HTMLElement} */ (item);
          const order = this.#getOrderValue(htmlItem, parseInt(htmlItem.dataset.columnIndex || '0', 10));
          
          if (isMobile) {
            // Mobile: hide if order is not 0 or 1
            if (order !== 0 && order !== 1) {
              htmlItem.classList.add(hiddenClass);
            } else {
              htmlItem.classList.remove(hiddenClass);
            }
          } else {
            // Desktop: hide if order is 3 or higher (0, 1, 2 are visible)
            if (order >= 3) {
              htmlItem.classList.add(hiddenClass);
            } else {
              htmlItem.classList.remove(hiddenClass);
            }
          }
        });

        // Update cells
        cells.forEach((cell) => {
          const htmlCell = /** @type {HTMLElement} */ (cell);
          const columnIndex = parseInt(htmlCell.dataset.columnIndex || '0', 10);
          const order = this.#getOrderValue(htmlCell, columnIndex);
          
          if (isMobile) {
            // Mobile: hide if order is not 0 or 1
            if (order !== 0 && order !== 1) {
              htmlCell.classList.add(hiddenClass);
            } else {
              htmlCell.classList.remove(hiddenClass);
            }
          } else {
            // Desktop: hide if order is 3 or higher (0, 1, 2 are visible)
            if (order >= 3) {
              htmlCell.classList.add(hiddenClass);
            } else {
              htmlCell.classList.remove(hiddenClass);
            }
          }
        });
      }

      /**
       * Finds which column contains a specific product ID.
       * @param {string} productId - The product ID to find.
       * @returns {number | null} The column index if found, null otherwise.
       */
      #findProductColumn(productId) {
        const table = this.querySelector('.td-products-comparison__table');
        if (!table) return null;

        // Find a cell with the product ID to get its column index
        const cell = table.querySelector(`td[data-product-id="${productId}"]`);
        if (!cell) return null;

        const htmlCell = /** @type {HTMLTableCellElement} */ (cell);
        return parseInt(htmlCell.dataset.columnIndex || '0', 10);
      }

      /**
       * Gets the current order value for an element (or column index if no order is set).
       * @param {HTMLElement} element - The element to check.
       * @param {number} columnIndex - The column index as fallback.
       * @returns {number} The current order value.
       */
      #getOrderValue(element, columnIndex) {
        const inlineOrder = element.style.order;
        if (inlineOrder) {
          return parseInt(inlineOrder, 10);
        }
        const computedOrder = getComputedStyle(element).order;
        if (computedOrder && computedOrder !== 'auto' && computedOrder !== '0') {
          return parseInt(computedOrder, 10);
        }
        return columnIndex;
      }

      /**
       * Swaps table columns by exchanging CSS order values.
       * @param {string} selectedProductId - The product ID that was selected.
       * @param {string} currentProductId - The current product ID in the column.
       * @param {number} currentColumnIndex - The current column index.
       */
      #swapColumns(selectedProductId, currentProductId, currentColumnIndex) {
        const table = this.querySelector('.td-products-comparison__table');
        if (!table) return;

        // Find the column that contains the selected product
        const selectedColumnIndex = this.#findProductColumn(selectedProductId);
        if (selectedColumnIndex === null || selectedColumnIndex === currentColumnIndex) {
          return;
        }

        // Get all table rows (excluding group title rows)
        const rows = Array.from(
          table.querySelectorAll('.td-products-comparison__table-row, .td-products-comparison__table-group-icon-row')
        );

        // Get current order values (check first row to get the order values)
        let currentOrder = currentColumnIndex;
        let selectedOrder = selectedColumnIndex;

        if (rows.length > 0 && rows[0]) {
          const firstRowCells = Array.from(rows[0].querySelectorAll('td[data-column-index]'));
          const currentCell = firstRowCells.find(
            (cell) => {
              const htmlCell = /** @type {HTMLElement} */ (cell);
              return parseInt(htmlCell.dataset.columnIndex || '0', 10) === currentColumnIndex;
            }
          );
          const selectedCell = firstRowCells.find(
            (cell) => {
              const htmlCell = /** @type {HTMLElement} */ (cell);
              return parseInt(htmlCell.dataset.columnIndex || '0', 10) === selectedColumnIndex;
            }
          );

          if (currentCell) {
            currentOrder = this.#getOrderValue(/** @type {HTMLElement} */ (currentCell), currentColumnIndex);
          }
          if (selectedCell) {
            selectedOrder = this.#getOrderValue(/** @type {HTMLElement} */ (selectedCell), selectedColumnIndex);
          }
        }

        // Swap order values in all rows
        rows.forEach((row) => {
          const cells = Array.from(row.querySelectorAll('td[data-column-index]'));

          cells.forEach((cell) => {
            const htmlCell = /** @type {HTMLTableCellElement} */ (cell);
            const columnIndex = parseInt(htmlCell.dataset.columnIndex || '0', 10);

            if (columnIndex === currentColumnIndex) {
              // Set current column's order to selected column's order
              htmlCell.style.order = selectedOrder.toString();
            } else if (columnIndex === selectedColumnIndex) {
              // Set selected column's order to current column's order
              htmlCell.style.order = currentOrder.toString();
            }
          });
        });

        // Swap order values in product cards grid
        const gridItems = Array.from(this.querySelectorAll('.td-products-comparison__item'));
        gridItems.forEach((item) => {
          const htmlItem = /** @type {HTMLElement} */ (item);
          const columnIndex = parseInt(htmlItem.dataset.columnIndex || '0', 10);

          if (columnIndex === currentColumnIndex) {
            htmlItem.style.order = selectedOrder.toString();
          } else if (columnIndex === selectedColumnIndex) {
            htmlItem.style.order = currentOrder.toString();
          }
        });

        // Update hidden classes after swapping
        this.#updateHiddenClasses();
      }
    }
    customElements.define('td-products-comparison', TdProductsComparison);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-tab-links"] && !Shopify.designMode) return;
  try {
    
  class TabLinks extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleScroll);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleScroll);
    }

    handleScroll = (event) => {
      const link = event.target.closest('.td-tab-links__link[data-scroll-link]');
      if (!link) return;

      event.preventDefault();
      const targetId = link.getAttribute('href');
      
      // Null check and validation for selector
      if (!targetId || !targetId.startsWith('#')) return;
      
      try {
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
          const header = document.querySelector('header-component') || document.querySelector('header') || document.querySelector('.section-header');
          const offset = header ? header.offsetHeight : 0;
          const topPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
          
          window.scrollTo({
            top: topPosition,
            behavior: 'smooth'
          });

          // A11y: Move focus to the target element
          if (!targetElement.hasAttribute('tabindex')) {
            targetElement.setAttribute('tabindex', '-1');
          }
          targetElement.focus({ preventScroll: true });
        }
      } catch (e) {
        console.warn('Tab links: Invalid selector', targetId);
      }
    };
  }

  if (!customElements.get('tab-links')) {
    customElements.define('tab-links', TabLinks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-user-manual"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Debounce utility function
    function debounce(fn, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          fn.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    class UserManualTabs extends HTMLElement {
      constructor() {
        super();
        this.productsData = null;
        this.searchInput = null;
        this.clearButton = null;
        this.debouncedSearch = null;
        this.noResultsMessage = null;
        this.productCards = null;
        this.groups = null;
      }

      connectedCallback() {
        this.tabButtons = this.querySelectorAll('.td-user-manual__group-nav-item[data-tab-id]');
        this.tabPanels = this.querySelectorAll('.td-user-manual__tab[data-tab-panel]');
        this.noResultsMessage = this.querySelector('.td-user-manual__no-results');
        this.productCards = this.querySelectorAll('.td-user-manual__product-card');
        this.groups = this.querySelectorAll('.td-user-manual__subgroup');

        // Initialize search
        this.initializeSearch();

        // Setup tab navigation
        this.tabButtons.forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            this.switchTab(button.dataset.tabId);
          });
        });
      }

      initializeSearch() {
        // Load product data from JSON
        const dataScript = document.getElementById('user-manual-products-data');
        if (dataScript) {
          try {
            this.productsData = JSON.parse(dataScript.textContent);
          } catch (e) {
            console.error('Error parsing product data:', e);
            return;
          }
        }
        this.searchInput = this.closest('.td-user-manual').querySelector('[id^="UserManualSearchInput--"]');

        if (!this.searchInput) return;

        // Setup debounced search
        this.debouncedSearch = debounce((searchTerm) => {
          this.filterProducts(searchTerm);
        }, 300);

        // Search input event listener
        this.searchInput.addEventListener('input', (e) => {
          const value = e.target.value.trim();
          this.debouncedSearch(value);
        });
      }

      filterProducts(searchTerm) {
        if (!this.productsData?.products) return;

        if (!searchTerm) {
          this.updateVisibility(new Set());
          return;
        }

        const searchLower = searchTerm.toLowerCase();
        const matchingInstanceIds = new Set();
        const products = this.productsData.products;

        // Optimized search - check all fields in one pass
        for (let i = 0; i < products.length; i++) {
          const product = products[i];
          if (!product.instanceId) continue;

          const title = product.title?.toLowerCase() || '';
          if (title.includes(searchLower)) {
            matchingInstanceIds.add(product.instanceId);
            continue;
          }

          const skus = product.skus;
          if (Array.isArray(skus) && skus.length > 0) {
            for (let j = 0; j < skus.length; j++) {
              if (skus[j]?.toLowerCase().includes(searchLower)) {
                matchingInstanceIds.add(product.instanceId);
                break;
              }
            }
            if (matchingInstanceIds.has(product.instanceId)) continue;
          }

          const variantTitles = product.variantTitles;
          if (Array.isArray(variantTitles) && variantTitles.length > 0) {
            for (let j = 0; j < variantTitles.length; j++) {
              if (variantTitles[j]?.toLowerCase().includes(searchLower)) {
                matchingInstanceIds.add(product.instanceId);
                break;
              }
            }
          }
        }

        this.updateVisibility(matchingInstanceIds);
      }

      updateVisibility(matchingInstanceIds) {
        const searchInputValue = this.searchInput?.value.trim() || '';
        const hasSearchTerm = searchInputValue !== '';
        const hasMatches = matchingInstanceIds.size > 0;
        const hiddenClass = 'td-user-manual__product-card--hidden';

        // Update product cards visibility
        for (let i = 0; i < this.productCards.length; i++) {
          const card = this.productCards[i];
          const instanceId = card.getAttribute('data-product-instance-id');

          if (!instanceId) {
            card.classList.add(hiddenClass);
            continue;
          }

          if (!hasSearchTerm || (hasMatches && matchingInstanceIds.has(instanceId))) {
            card.classList.remove(hiddenClass);
          } else {
            card.classList.add(hiddenClass);
          }
        }

        // If searching and no matches, hide everything and show message only
        if (hasSearchTerm && !hasMatches) {
          for (let i = 0; i < this.groups.length; i++) {
            this.groups[i].classList.add('td-user-manual__subgroup--hidden');
          }

          for (let i = 0; i < this.tabButtons.length; i++) {
            const button = this.tabButtons[i];
            const tabListItem = button.closest('.td-user-manual__navigation-item');
            button.style.display = 'none';
            if (tabListItem) {
              tabListItem.classList.add('td-user-manual__navigation-item--hidden');
            }
          }

          if (this.noResultsMessage) {
            this.noResultsMessage.style.display = 'block';
          }
          return;
        }

        if (this.noResultsMessage) {
          this.noResultsMessage.style.display = 'none';
        }

        // Update groups visibility
        for (let i = 0; i < this.groups.length; i++) {
          const group = this.groups[i];
          const groupCards = group.querySelectorAll('.td-user-manual__product-card');
          let hasVisible = false;

          for (let j = 0; j < groupCards.length; j++) {
            if (!groupCards[j].classList.contains(hiddenClass)) {
              hasVisible = true;
              break;
            }
          }

          group.classList.toggle('td-user-manual__subgroup--hidden', !hasVisible);
        }

        // Update tabs visibility and track tabs with results
        const tabsWithResults = [];
        const tabPanelsMap = new Map();
        this.tabPanels.forEach((panel) => {
          tabPanelsMap.set(panel.dataset.tabPanel, panel);
        });

        for (let i = 0; i < this.tabButtons.length; i++) {
          const button = this.tabButtons[i];
          const tabId = button.dataset.tabId;
          const tabPanel = tabPanelsMap.get(tabId);
          const tabListItem = button.closest('.td-user-manual__navigation-item');

          let shouldHide = false;
          let hasVisibleGroups = false;

          if (hasSearchTerm) {
            if (tabPanel) {
              const tabGroups = tabPanel.querySelectorAll('.td-user-manual__subgroup');
              for (let j = 0; j < tabGroups.length; j++) {
                if (!tabGroups[j].classList.contains('td-user-manual__subgroup--hidden')) {
                  hasVisibleGroups = true;
                  break;
                }
              }
              shouldHide = !hasVisibleGroups;
            } else {
              shouldHide = true;
            }
          } else if (tabPanel) {
            hasVisibleGroups = tabPanel.querySelectorAll('.td-user-manual__subgroup').length > 0;
          }

          if (shouldHide) {
            button.style.display = 'none';
            if (tabListItem) {
              tabListItem.classList.add('td-user-manual__navigation-item--hidden');
            }
          } else {
            button.style.display = '';
            if (tabListItem) {
              tabListItem.classList.remove('td-user-manual__navigation-item--hidden');
            }
            if (hasVisibleGroups || !hasSearchTerm) {
              tabsWithResults.push(tabId);
            }
          }
        }

        // Auto-switch to first tab with results if active tab has none
        if (hasSearchTerm && tabsWithResults.length > 0) {
          let activeButton = null;
          for (let i = 0; i < this.tabButtons.length; i++) {
            if (this.tabButtons[i].classList.contains('active') && this.tabButtons[i].style.display !== 'none') {
              activeButton = this.tabButtons[i];
              break;
            }
          }

          if (!activeButton) {
            for (let i = 0; i < this.tabButtons.length; i++) {
              const btn = this.tabButtons[i];
              if (tabsWithResults.includes(btn.dataset.tabId) && btn.style.display !== 'none') {
                this.switchTab(btn.dataset.tabId);
                break;
              }
            }
          } else {
            const activeTabPanel = tabPanelsMap.get(activeButton.dataset.tabId);
            if (activeTabPanel) {
              const activeTabGroups = activeTabPanel.querySelectorAll('.td-user-manual__subgroup');
              let hasVisible = false;
              for (let i = 0; i < activeTabGroups.length; i++) {
                if (!activeTabGroups[i].classList.contains('td-user-manual__subgroup--hidden')) {
                  hasVisible = true;
                  break;
                }
              }

              if (!hasVisible) {
                for (let i = 0; i < this.tabButtons.length; i++) {
                  const btn = this.tabButtons[i];
                  if (tabsWithResults.includes(btn.dataset.tabId) && btn.style.display !== 'none') {
                    this.switchTab(btn.dataset.tabId);
                    // Open first visible group in the newly switched tab
                    this.openFirstVisibleGroup(btn.dataset.tabId, tabPanelsMap);
                    break;
                  }
                }
              } else {
                // Active tab has visible groups, open the first one
                this.openFirstVisibleGroup(activeButton.dataset.tabId, tabPanelsMap);
              }
            }
          }
        } else if (hasSearchTerm && hasMatches) {
          // If searching and we have matches, find active tab and open first visible group
          let activeButton = null;
          for (let i = 0; i < this.tabButtons.length; i++) {
            if (this.tabButtons[i].classList.contains('active') && this.tabButtons[i].style.display !== 'none') {
              activeButton = this.tabButtons[i];
              break;
            }
          }
          if (activeButton) {
            this.openFirstVisibleGroup(activeButton.dataset.tabId, tabPanelsMap);
          }
        }
      }

      openFirstVisibleGroup(tabId, tabPanelsMap) {
        const tabPanel = tabPanelsMap.get(tabId);
        if (!tabPanel) return;

        const tabGroups = tabPanel.querySelectorAll('.td-user-manual__subgroup');
        for (let i = 0; i < tabGroups.length; i++) {
          const group = tabGroups[i];
          if (group.classList.contains('td-user-manual__subgroup--hidden')) continue;

          // Find the disclosure trigger and content within this group
          const disclosureTrigger = group.querySelector('.disclosure-trigger');
          const disclosureContent = group.querySelector('.disclosure-content');

          if (disclosureTrigger && disclosureContent) {
            // Open the disclosure (matching the logic from disclosure-custom.js)
            disclosureTrigger.setAttribute('aria-expanded', 'true');
            disclosureTrigger.setAttribute('aria-label', disclosureTrigger.dataset.disclosureClose || 'Close');
            disclosureContent.inert = false;
            break; // Only open the first visible group
          }
        }
      }

      clearSearch() {
        if (this.searchInput) {
          this.searchInput.value = '';
          this.filterProducts('');
        }

        // Show all tab navigation items when search is cleared
        for (let i = 0; i < this.tabButtons.length; i++) {
          const button = this.tabButtons[i];
          const tabListItem = button.closest('.td-user-manual__navigation-item');
          button.style.display = '';
          if (tabListItem) {
            tabListItem.classList.remove('td-user-manual__navigation-item--hidden');
          }
        }
      }

      switchTab(tabId) {
        for (let i = 0; i < this.tabButtons.length; i++) {
          const button = this.tabButtons[i];
          const isActive = button.dataset.tabId === tabId;
          button.classList.toggle('active', isActive);
          button.setAttribute('aria-selected', isActive);
        }

        for (let i = 0; i < this.tabPanels.length; i++) {
          const panel = this.tabPanels[i];
          const isActive = panel.dataset.tabPanel === tabId;
          panel.classList.toggle('td-user-manual__tab--hidden', !isActive);
          panel.setAttribute('aria-hidden', !isActive);
        }
      }
    }

    if (!customElements.get('user-manual-tabs')) {
      customElements.define('user-manual-tabs', UserManualTabs);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-ways-to-earn"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.td-ways-to-earn');

  sections.forEach(function(section) {
    const seeAllBtn = section.querySelector('.td-ways-to-earn__see-all');

    if (seeAllBtn) {
      seeAllBtn.addEventListener('click', function() {
        const parent = section.closest('.td-ways-to-earn');
        if (parent) {
          parent.classList.toggle('is-expanded');
          const isExpanded = parent.classList.contains('is-expanded');
          seeAllBtn.setAttribute('aria-expanded', isExpanded);
        }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
